"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _PromptContainer = _interopRequireDefault(require("./PromptContainer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var promptInst = null;

var getPromptInst = function getPromptInst() {
  return new Promise(function (resolve) {
    if (!promptInst) {
      var div = document.createElement('div');
      document.body.appendChild(div);
      (0, _reactDom.render)( /*#__PURE__*/React.createElement(_PromptContainer["default"], {
        ref: function ref(el) {
          promptInst = el;
          resolve();
        }
      }), div);
    } else {
      resolve();
    }
  });
};

var prompt = {
  alert: function alert(msg, onConfirm, buttonText) {
    getPromptInst().then(function () {
      promptInst.add({
        msg: msg,
        onConfirm: onConfirm,
        type: 'alert',
        buttonText: buttonText
      });
    });
  },
  confirm: function confirm(msg, onConfirm, onCancel, confirmText, cancelText, onClose) {
    getPromptInst().then(function () {
      promptInst.add({
        msg: msg,
        onConfirm: onConfirm,
        onCancel: onCancel,
        type: 'confirm',
        confirmText: confirmText,
        cancelText: cancelText,
        onClose: onClose
      });
    });
  }
};
var _default = prompt;
exports["default"] = _default;